module.exports = __webpack_public_path__ + "img/logo.651a5dff.svg";